/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";
// javascript plugin used to create scrollbars on windows
//import PerfectScrollbar from "perfect-scrollbar";
import {validateLogin} from '../../../utils/validateLogin'

// core components
import AdminNavbar from "../../components/Navbars/AdminNavbar.js";
import Footer from "../../components/Footer/Footer.js";
import Sidebar from "../../components/Sidebar/Sidebar.js";
import FixedPlugin from "../../components/FixedPlugin/FixedPlugin.js";


import ThemeContextWrapper from "../../components/ThemeWrapper/ThemeWrapper";
import BackgroundColorWrapper from "../../components/BackgroundColorWrapper/BackgroundColorWrapper";

import routes from "../../routes.js";
import UserProfile from "../../views/UserProfile.js";
import FormAdminPlaces from "../../views/FormAdminPlaces.js";
import FormAddActToCity from "../../views/FormAddActToCity.js";

import logo from "../../assets/img/react-logo.png";
import { BackgroundColorContext } from "../../contexts/BackgroundColorContext";



import "../../assets/css/black-dashboard-react.css";
import "../../assets/css/nucleo-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

//var ps;

function Admin(props) {
  const location = useLocation();
  const mainPanelRef = React.useRef(null);
  const [sidebarOpened, setsidebarOpened] = React.useState(
    document.documentElement.className.indexOf("nav-open") !== -1
  );
  React.useEffect(() => {
    /*if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.className += " perfect-scrollbar-on";
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(mainPanelRef.current, {
        suppressScrollX: true,
      });
      let tables = document.querySelectorAll(".table-responsive");
      for (let i = 0; i < tables.length; i++) {
        //ps = new PerfectScrollbar(tables[i]);
      }
    }*/
    // Specify how to clean up after this effect:
    return function cleanup() {
      /*if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
        document.documentElement.classList.add("perfect-scrollbar-off");
        document.documentElement.classList.remove("perfect-scrollbar-on");
      }*/
    };
  });
  React.useEffect(() => {
    /*if (navigator.platform.indexOf("Win") > -1) {
      let tables = document.querySelectorAll(".table-responsive");
      for (let i = 0; i < tables.length; i++) {
        //ps = new PerfectScrollbar(tables[i]);
      }
    }*/
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainPanelRef.current) {
      mainPanelRef.current.scrollTop = 0;
    }
  }, [location]);
  // this function opens and closes the sidebar on small devices
  const toggleSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    setsidebarOpened(!sidebarOpened);
  };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (location.pathname.indexOf(routes[i].layout + routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
    return "Brand";
  };
  return (
    <ThemeContextWrapper>
      <BackgroundColorWrapper>
        <BackgroundColorContext.Consumer>
          {({ color, changeColor }) => (
            <div className= 'adminCont'>
              <div className="wrapper">
                <Sidebar
                  routes={routes}
                  logo={{
                    outterLink: "",
                    text: "Tripendar",
                    imgSrc: logo,
                  }}
                  toggleSidebar={toggleSidebar}
                />
                <div className="main-panel" ref={mainPanelRef} data={color}>
                  <AdminNavbar
                    brandText={getBrandText(location.pathname)}
                    toggleSidebar={toggleSidebar}
                    sidebarOpened={sidebarOpened}
                  />
                  <Switch>
                    {getRoutes(routes)}
                    <Route 
                    path='/admin/edit-profile/:id' 
                    component={UserProfile} key={'adminEdit'}/>
                    <Route 
                    path='/admin/user-profile' 
                    component={UserProfile} key={'userEdit'}/>
                    <Route 
                    path='/admin/edit-Activity/:id' 
                    component={FormAdminPlaces} key={'ActEdit'}/>
                    <Route 
                    path='/admin/add-Activities/:id' 
                    component={FormAddActToCity} key={'AddAct'}/>
                    
                    <Redirect from="*" to="/admin/dashboard" />
                  </Switch>
                  {
                    // we don't want the Footer to be rendered on map page
                    location.pathname === "/admin/maps" ? null : <Footer fluid />
                  }
                </div>
              </div>
              {/* <FixedPlugin bgColor={color} handleBgClick={changeColor} /> */}
            </div>
          )}
        </BackgroundColorContext.Consumer>
      </BackgroundColorWrapper>
  </ThemeContextWrapper>
  );
}

export default validateLogin(Admin);
